var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAudioOn = function SvgAudioOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.945 1.379l-.652.763A7.968 7.968 0 0114.863 8a7.972 7.972 0 01-2.57 5.858l.651.763a8.966 8.966 0 00.001-13.242zm-2.272 2.66l-.651.763a4.484 4.484 0 01-.001 6.397l.651.763A5.48 5.48 0 0012.363 8c0-1.557-.65-2.962-1.69-3.962zM0 4.999v6h2.804L8 14V2L2.804 5H0zm7-1.267v8.536L3.072 10H1V6h2.072L7 3.732z",
    fill: "#fff"
  })));
};
export default SvgAudioOn;